// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2F56p","footer":"ReportModalFilter_footer__2Yq1l"};